export default {
  CreateRule: '新建规则',
  EditRule: '编辑规则',
  BatchAssociatedGateway: '批量关联网关',
  SearchRuleName: '搜索规则名称/关联网关/分支机构/来源ip/目标ip/域名',
  RuleName: '规则名称',
  Priority: '优先级',
  CreateTime: '创建时间',
  GateWay: '关联网关',
  UserId: '创建人账号',
  Role: '创建人角色',
  Operating: '操作',
  TotalItem: (val: number) => `共${val}项`,
  Edit: '编辑',
  Delete: '删除',
  IsDeleteRule: '您确定要删除吗?',
  Sure: '确定',
  Cancel: '取消',
  SrcIp: '来源ip',
  SrcPort: '来源端口',
  DestIp: '目标ip',
  DestPort: '目标端口',
  DeleteSuccess: '删除成功',
  DeleteError: '删除失败,请稍后重试',
  RelatSuccess: '关联成功',
  RelatedGateway: '已关联网关',
  ConfiguredRules: '已配置规则',
  PriorityPromp: '优先级为1-50的正整数',
  ChangeSuccess: '修改成功',
  AddSuccess: '添加成功',
  SettingRule: '设置规则',
  Next: '下一步',
  Previous: '上一步',
  PleaseSelect: '请选择',
  PleaseSelectApp: '请选择应用',
  BaseOnFiveTuple: '基于五元组',
  BaseOnApp: '基于应用DPI',
  PleaseWrite: '请填写',
  PlotNameExamp: '支持长度2-20字符的中英文、数字、下划线、减号',
  RuleType: '规则类型',
  RuleTypeMsg: '请选择规则类型',
  ProtocolType: '协议类型',
  Protocol: '协议',
  SelectProtocolType: '请选择协议类型',
  SrcIpInputMsg: '请填写来源ip',
  SrcIpPH: '请填写单一IP地址或者CIDR网段格式，放空视为不限',
  IpExamp: '例：192.168.10.10 或 192.168.10.0/24',
  SrcPortInputMsg: '请填写来源端口',
  SrcPortPH: '请填写端口范围，取值范围从1到65535，放空视为不限',
  PortExamp: '例：1-200或80',
  DestIpMsg: '请填写单一IP地址或者CIDR网段格式，放空视为不限',
  DestPortMsg: '请填写目标端口',
  OriginIpToolTip1: '出方向：本地分支发起访问的源地址所在网段。',
  OriginIpToolTip2: '入方向：从外部发起访问的源地址所在网段。', // 来源ip输入框的提示信息
  TargetIpToolTip1: '出方向：要访问的外部的目标网段。',
  TargetIpToolTip2: '入方向：要访问的本地分支的目标网段。',
  Unfold: '展开',
  PutAway: '收起',
  GatewayName: '网关名',
  DeviceName: '设备名',
  SelectGateway: '选择关联网关',
  Selected: '已选择',
  RelatedRules: '关联规则数',
  PriorityExamp: '数值越小，优先级越高。相同优先级将按照创建时间早的优先生效。',
  CurrentRuleRelated: '当前规则关联多条网关，请前往',
  AloneSet: '单独设置', // CurrentRuleRelated和AloneSet本为一句话，由于中间有可点击链接，所以拆开，原句为：当前规则关联多条网关，请前往已关联网关单独设置
  UnLimit: '不限',
  Export: '导出',
  Exporting: '导出中',
  ExportSuccess: '导出成功',
  MaxExportLength: '最大只支持导出$1条',
  Today: '今天',
  Yesterday: '昨天',
  IPErrorTips: '输入格式错误，请修改',
  NearlyDay: (date: number) => `近${date}天`,
  Remove: '移除',
  IsRemoveRule: '您确定要移除吗?',
  RemoveSuccess: '移除成功',
  RemoveError: '移除失败,请稍后重试',
  GatewayList: '网关实例',
  AccessControl: '访问控制',
  Qos: 'QoS策略',
  FlowLog: '流量记录',
  ControlLog: '管控日志',
  Wait: '等',
  Item: '个', // wait和item本为一句话，由于中间穿插了ReactElement所以拆分，原句为等num个
  IPError: 'IP格式有误',
  PortError: '端口格式有误',
  FlowControl: '流量管控',
  AccountCenter: '账户中心',
  SafeSet: '安全设置',
  Exit: '退出',
  BaishanCloud: '白山云科技',
  UserName: '用户名',
  Save: '保存 ',
  PurchaseBandwidth: '采购带宽',
  NoData: '暂无数据',
  Individual: '个',
  Cpe: '设备',
  AccessRule: '访问规则',
  Overview: '概览',
  IpNotEqual: '来源IP不能与目标IP相同',
  PortRange: '端口号范围应该从小到大',
  NameWarning: '名称必须是2-20个字符的中英文、数字、下划线、减号',
  OperationSuccessful: '操作成功',
  OperationFailed: '操作失败',
  PurchaseAllBandwidth: '采购总带宽',
  DefaultPriority: '默认优先级',
  ALL: '全部',
  EditSuccess: '编辑成功',
  NetPartRange: '网段范围为1-32',
  SearchGatewayName: '搜索网关名称/设备名称',
  Minute: '分钟',
  NextErrorTip: '为保障访问控制效果，五元组信息（除协议以外）至少需要限制一项',
  MaxRuleNum: (val: number) => `同一网关关联的规则数量最多${val}条`,
  RelatedQos: '关联策略数',
  MaxQosNum: '同一网关最多只能关联10条策略',
  SearchNetName: '搜索网关号',
  BatchControl: '批量管理',
  RelationErr: '关联失败',
  DeletedNoRestore: '删除后不可恢复，如有需要请重新添加',
  isRequireNotBlank: (title: string) => `${title}不支持输入空格，请修改`,
  SaveSuccess: '保存成功',
  Refresh: '刷新',
  Interface: '口',
  Modify: '修改',
  Config: '配置',
  Enable: '启用',
  StopUsing: '停用',
  Close: '关闭',
  Open: '开启',
  OrderNumber: '序号',
  AddPolicy: '新建策略',
  EditPolicy: '编辑策略',
  IPAddressError: '输入的格式错误，请填写正确的ip地址或地址段',
  Remark: '备注',
  ConfigModifySuccess: '配置修改成功',
  PriorityInvalid: '优先级为1-200的正整数',
  WeightInvalid: '权重为0-50的正整数',
  Status: '状态',
  Mapping: '映射',
  NotConfigured: '未配置',
  Configured: '已配置',
  Setting: '设置',
  Success: '成功',
  PleaseAddFirst: '请先添加',
  Rule: '规则',
  PortValueErrorTips: '端口取值范围为1到65535',
  SituationCenter: '态势中心',
  BranchType: '分支类型',
  China: '中国',
  PleaseInput: '请输入',
  Attention: '注意',
  Document: '帮助文档',
  Normal: '正常',
  BreakDown: '故障',
  GatewayID:'网关号',
  Branch: '分支机构',
  AssociatedDevices: '关联设备',
  ClearAllPlaceholder: '确定清空全部已选项？',
  Clear: '清空',
  Switch: '开关',
  APP: '应用',
  Type: '类型',
  Map: '地图',
  NetworkTopology: '组网拓扑',
  Start: '开始',
  Stop: '停止',
  OperationLog: '操作日志',
  UserBehaviorLog: '用户行为日志',
  CrossBorder: '跨境业务',
  ChannelManagement: '渠道管理',
  PopServers: 'pop信息',
  PrivateLine: '线路信息',
  UserOrder: '客户列表',
  Channel: '渠道',
  UserWhitelist: '用户白名单',
  Detail: '详情',
  NetTopology: '网络拓扑',
  Permission: '权限',
  LineStatus: '线路状态',
  Search: '搜索',
}